import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getUserSsoConfig } from '../../modules/auth.js';

const SsoRedirectPage = ({ getUserSsoConfig }) => {
  const [searchParams] = useSearchParams();
  const organization = searchParams.get('organization');
  const [isInitiating, setIsInitiating] = useState(false);
  const [localError, setLocalError] = useState(null);

  const initiateSsoSignIn = async (orgSsoConfig) => {
    if (typeof window !== 'undefined' && window.OktaAuth) {
      if (
        !orgSsoConfig.issuer ||
        (!orgSsoConfig.clientId && !orgSsoConfig.client_id)
      ) {
        return;
      }

      const oktaInstance = new window.OktaAuth({
        issuer: orgSsoConfig.issuer,
        clientId: orgSsoConfig.clientId || orgSsoConfig.client_id,
        redirectUri: `${window.location.origin}/login/callback`,
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
        responseType: 'code',
        state: btoa(JSON.stringify(orgSsoConfig)),
        tokenManager: {
          autoRenew: false,
        },
      });

      try {
        await oktaInstance.signInWithRedirect({
          originalUri: window.location.href,
          state: btoa(JSON.stringify(orgSsoConfig)),
        });
      } catch (error) {
        setLocalError(
          error.errorSummary ||
            error.message ||
            'Failed to initiate SSO sign-in'
        );
        setIsInitiating(false);
      }
    } else {
      setIsInitiating(false);
    }
  };

  useEffect(() => {
    if (organization && !isInitiating) {
      setIsInitiating(true);
      getUserSsoConfig(organization)
        .then((response) => {
          if (
            response &&
            (response.issuer || response.client_id || response.clientId)
          ) {
            initiateSsoSignIn(response);
          } else {
            setLocalError('No SSO configuration data received');
            setIsInitiating(false);
          }
        })
        .catch((error) => {
          setLocalError(error.message || 'Failed to fetch SSO configuration');
          setIsInitiating(false);
        });
    }
  }, [organization]);

  if (localError) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}
      >
        <div style={{ color: 'red', marginBottom: '20px' }}>{localError}</div>
      </div>
    );
  }

  if (isInitiating) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}
      >
        <div>Loading...</div>
        <div style={{ marginTop: '20px' }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <div>Redirecting to SSO...</div>
      <div style={{ marginTop: '10px', color: '#666' }}>
        If you are not redirected automatically, please try again.
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getUserSsoConfig,
};

export default connect(null, mapDispatchToProps)(SsoRedirectPage);
